import React from 'react';
import { Table, Column, Cell } from 'fixed-data-table-2';

class LeaksDataTable extends React.Component {

  cellScoreSelectedGroupData = (row) => {
    const { data } = this.props;
    const { factor, units } = this.props.measurmentsDetails;

    let cellValue;
    let className = 'table-cell-class';
    switch (row.columnKey) {
      case 'LeakPerKm': {
        const count = data[row.rowIndex].alertsCount;
        const pipeLength = data[row.rowIndex].PipeLength;
        cellValue = (count / (pipeLength / 1000)).toFixed(1);
        className += ' number';
        break;
      }
      case 'PipeLength': {
        const bigUnitObj = factor.bigUnitValue[units];
        cellValue = (data[row.rowIndex].PipeLength * factor[units]).toFixed();

         let unit;
         let val;
         if (cellValue < bigUnitObj.value) {
            unit = units;
            val = cellValue;
         } else {
            unit = bigUnitObj.label;
            val = (Number(cellValue) / bigUnitObj.value).toFixed(1);
         }
         cellValue = `${val} ${unit}`;
         className += ' number';
        break;
      }
      default: {
        cellValue = data[row.rowIndex][row.columnKey]
        break;
      }
    }

    return <Cell className={className}>{cellValue}</Cell>
  }

  onTableRowClick = (event, rowIndex) => {
    const { data, category, onSelectGroup } = this.props;

    const clickedRow = data[rowIndex];

    const filter = {
       'YearMaterialDiameter': clickedRow.key,
       'Category': category
    };

    onSelectGroup(filter);
  }

  render() {
    const { data, title, isFetching = false, renderLoading, context, factor, units } = this.props;

    const cardStyle = {
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      border: '1px solid #e8f4f8',
      padding: '16px',
    };

    const titleStyle = {
      color: '#2c3e50',
      fontSize: '1.5rem',
      fontWeight: 600,
      margin: '0 0 16px 0',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      borderBottom: '3px solid #75cae3',
      paddingBottom: '10px',
    };

    return (
    <div style={cardStyle}>
      <p style={titleStyle}>{title}</p>
      {
        isFetching && renderLoading()
      }
      { isFetching === false &&
        <Table
          height={280}
          width={448}
          rowsCount={data.length}
          rowHeight={40}
          headerHeight={40}
          onRowClick={this.onTableRowClick}
        >
          <Column columnKey="PlacementYear" width={30}
              header={<Cell className="pca-table-header">{context('Placement Year')}</Cell>}
              cell={this.cellScoreSelectedGroupData}
              align='center'
              flexGrow={1} />
          <Column columnKey="Material" width={30}
              header={<Cell className="pca-table-header">{context('Material')}</Cell>}
              cell={this.cellScoreSelectedGroupData}
              align='center'
              flexGrow={1} />
          <Column columnKey="PipeDiameterInch" width={30}
              header={<Cell className="pca-table-header">{context('Pipe Diameter')}</Cell>}
              cell={this.cellScoreSelectedGroupData}
              align='center'
              flexGrow={1} />
          <Column columnKey="PipeLength" width={30}
              header={<Cell className="pca-table-header">{context('Pipe Length')}</Cell>}
              cell={this.cellScoreSelectedGroupData}
              align='center'
              flexGrow={1} />
          <Column columnKey="alertsCount" width={30}
              header={<Cell className="pca-table-header">{context('Leaks')}</Cell>}
              cell={this.cellScoreSelectedGroupData}
              align='center'
              flexGrow={1} />
        </Table>
      }
    </div>
    );
  }
}
export default LeaksDataTable;
